export const whatsappLink = "https://wa.me/message/EQKGZPEJKMUMG1";
export const instagramLink =
  "https://instagram.com/anda.pay?igshid=YmMyMTA2M2Y=";
export const youtubeLink =
  "https://www.youtube.com/channel/UC_f2xwdLa632CqUQXQJp-pA";
export const linkedinLink = "https://www.linkedin.com/company/andapay/";
export const twitterLink = "https://twitter.com/andapay_co";
export const ipLink = "https://api.ipify.org?format=json";
